export default __webpack_public_path__ + "static/media/bear.11022c39.png";